import { DestroyRef, Directive, EmbeddedViewRef, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { MediaQuerySize, SvcMediaQuery } from '../services/svc-media-query.service';

class ScreenSizesContext {
  public $implicit: MediaQuerySize = null!;
}

@Directive({
  // eslint-disable-next-line
  selector: '[screenSizes]',
})
export class ScreenSizesDirective {
  private size: MediaQuerySize = <MediaQuerySize>{};

  #view: EmbeddedViewRef<ScreenSizesContext> | undefined;
  #destroyRef = inject(DestroyRef);
  #viewContainer = inject(ViewContainerRef);
  #templateRef = inject(TemplateRef<ScreenSizesContext>);
  #mediaQuery = inject(SvcMediaQuery);

  screenSizes = input<string>();

  static ngTemplateGuard_screenSizes: 'binding';

  constructor() {
    this.#mediaQuery.size$
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        tap((size) => {
          this.size = size;
          if (this.#view) {
            this.#view.context.$implicit = this.size;
            this.#view.markForCheck();
          } else {
            this.#view = this.#viewContainer.createEmbeddedView(this.#templateRef!, {
              $implicit: this.size,
            });
          }
        })
      )
      .subscribe();
  }

  static ngTemplateContextGuard(dir: ScreenSizesDirective, ctx: any): ctx is ScreenSizesContext {
    return true;
  }
}
